import React, { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import NavBar from "../../../../../../components/nav-bar/nav-bar";
import Modal from "../../../../../../components/modal/modal";
import { APP_BASE_PATHNAMES } from "../../../../../../core/consts/consts";
import styles from "./load-failure-modal.module.scss";
import { useIntercom } from "react-use-intercom";
interface Props {
  onNavbackClick: () => void;
  modalTitle: ReactNode;
}

export function LoadFailureModal(props: Props) {
  const { t } = useTranslation();
  const { show } = useIntercom();
  const handleIntercomClick = () => {
    show();
  };

  return (
    <Modal
      fullWidth={true}
      title={props.modalTitle}
      navBar={
        <NavBar
          mode={"back"}
          to={`/${APP_BASE_PATHNAMES.CONNECT}`}
          onClick={props.onNavbackClick}
        />
      }
      data-testid={"load-failure-modal"}
    >
      <div className={styles.Wrapper}>
        <p className={styles.P}>
          <strong>{t("updateSubscriptionInformation")}</strong>
          <br />
          It seems this subscription is still linked to a previous owner. To
          update your payment information and associate it with your
          subscription, please{" "}
          <a onClick={handleIntercomClick}>contact our support team</a> for
          help.
        </p>
      </div>
    </Modal>
  );
}

export default LoadFailureModal;
